export enum RequirementCategoryType {
  EVIDENCE = 'evidence',
  DESIGN = 'design',
}

export interface RequirementEvidenceCategoryParams {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  requirementId: string;
  name: string;
  description?: string | null;
  type: RequirementCategoryType;
}

export interface RequirementEvidenceCategoryData {
  id: string;
  createdAt?: string;
  updatedAt?: string;
  requirementId: string;
  name: string;
  description?: string | null;
  type: RequirementCategoryType;
}

export type RequirementEvidenceCategoryCreateData = Omit<
  RequirementEvidenceCategoryData,
  'id' | 'createdAt' | 'updatedAt'
>;

export interface RequirementEvidenceCategoryUpdateData {
  id: string;
  name: string;
  description?: string | null;
}
